module.exports = __webpack_public_path__ + "static/media/hospmang1.c2285cbf.png";